<template>
  <!-- <transition name="slide"> -->
  <div class="mt-4">
    <h2 class="text-lg font-bold text-dark-blue mb-6">{{ question.content[$locale()] }}</h2>
    <div class="grid grid-cols-6 responses">
      <div v-for="(response, key) in question.responses" :key="key" class="flex flex-col items-center">
        <label :for="question.id+'-'+key" v-if="response.id" class="text-sm mb-1 font-semibold">{{
            response.id
          }}</label>
        <div class="bg-light-blue w-full py-3 mb-2 border-r border-gray-300">
          <input type="radio"
                 :id="question.id+'-'+key"
                 :name="'question-'+question.id"
                 :value="modelValue"
                 @change="$emit('update:modelValue', { 'question_id': question.id , 'response_id': response.id })"
                 class="bg-light-blue p-2 border-2 border-medium-blue text-dark-blue"/>
        </div>
        <label :for="question.id+'-'+key" v-if="response.content" class="text-sm">{{
            response.content[$locale()]
          }}</label>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
export default {
  name: "SurveyQuestion",
  props: {
    modelValue: Object,
    question: Object
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>

div.responses div:first-child div {
  @apply rounded-l-lg;
}

div.responses div:last-child div {
  @apply rounded-r-lg border-r-0;
}

</style>
